import { MapPinIcon, PlusIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { DeliveryRoutes } from "../../components/delivery-routes"
import { DeliveryActionButton } from "../../components/delivery/action-controls"
import { useDeliveryActions } from "../../components/delivery/delivery-actions"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"

export function DeliveryRoutesPage() {
  const { t } = useTranslation(["delivery", "common"])
  const navigate = useNavigate()
  // delivery-route/list.ts: ORD_DN_MNG | DEL_ROUTE_PLAN.
  const ORD_DN_MNG = usePermission("ORD_DN_MNG")
  const DEL_ROUTE_PLAN = usePermission("DEL_ROUTE_PLAN")
  const hasAccess = ORD_DN_MNG.hasAccess || DEL_ROUTE_PLAN.hasAccess
  const { permissionState } = useDeliveryActions()
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<MapPinIcon size={22} />}
      title={t("delivery:route.title")}
      subTitle={t("delivery:route.subtitle")}
      breadcrumb={breadcrumbs}
      extra={
        hasAccess
          ? [
              <DeliveryActionButton
                key="new"
                state={permissionState("createRoute")}
                leftSection={<PlusIcon size={18} />}
                onClick={() => navigate("/delivery-routes/new")}
              >
                {t("delivery:route.list.new")}
              </DeliveryActionButton>,
            ]
          : undefined
      }
    >
      {hasAccess ? <DeliveryRoutes /> : DEL_ROUTE_PLAN.accessDenied()}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { label: t("delivery:route.title") },
]
